/*
 * @Author: yzr
 * @Date: 2020-12-01 12:57:18
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-01 12:57:19
 */
import SalesArea from './sales_area.vue';

export default SalesArea;
